import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const sorteioInit = function () {
  return {
    paginas: 1,
    cupons: [],
  };
};

export default new Vuex.Store({
  state: {
    carregandoCupons: false,
    sorteio: sorteioInit(),
    pesquisa: "",
    buscou_cupom: false,
    consultar_cupom: false,
    link_regulamento:
      "https://www.coasul.com.br/coasul-55-anos-55-motivos-para-comemorar/Regulamento%20Promocao%20Coasul%2055%20Anos.pdf",
  },
  getters: {},
  mutations: {
    setCarregandoCupons(state, value) {
      state.carregandoCupons = value;
    },
    setSorteio(state, value) {
      state.sorteio = value;
    },
    setPesquisa(state, value) {
      state.pesquisa = value;
    },
    setBuscouCupom(state, value) {
      state.buscou_cupom = value;
    },
    resetSorteio(state) {
      state.sorteio = sorteioInit();
    },
    setConsultarCupom(state, value) {
      state.consultar_cupom = value;
    },
  },
  actions: {
    async getCupons(context) {
      context.commit("setBuscouCupom", true);
      context.commit("setCarregandoCupons", true);
      context.commit("resetSorteio");

      await axios
        .get("/cupons-55-anos/consulta-cupons", {
          params: {
            cpf: context.state.pesquisa,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            context.commit("setSorteio", res.data);
          }
        });

      context.commit("setCarregandoCupons", false);
    },
  },
  modules: {},
});
